import {Injectable} from '@angular/core';
import {TradeInstructionsComponent} from '@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component';
import {optionOrderTypes} from '../trade-instructions.model';

@Injectable({
    providedIn: 'root',
})
export class SpreadOptionAction {
    /*
         * IREBALOPNS-1843
         * Create and Edit Trade Instructions modal for Spread orders
         */
    spreadOptionAction(action: any, parent: TradeInstructionsComponent, response?: any) {
        const self = parent;
        const item = self.data;
        if (item.securityType === "OPTION" && item.optionStrategyType === "SPREAD") {

            switch (action) {
                case "isSpreadOrder":
                    if (item.orderType === "LIMIT" || item.orderType === "MARKET") {
                        return true;
                    }
                    break;
                case "setValues":
                    self.layoutFieldsShowHide.layExpirationtype = false;
                    self.layoutFieldsShowHide.layexpirationdate = false;
                    self.layoutFieldsShowHide.layNotHeld = false;
                    self.layoutFieldsShowHide.layDestination = false;

                    self.priceTypeRadioDisplayHide(self.orderTypeSelected.id, "orderddfun"); // hide radio buttons by default if order type is not Limit
                    self.limitInstructionTextVisible = false;

                    const orderType = self.orderTypeSelected.id;
                    if (orderType === "LIMIT" && self.optionOrderTypeSelected) {
                        const optionOrderType = self.optionOrderTypeSelected.id;

                        if (optionOrderType === "EVEN_MONEY") {
                            self.priceDisabled = true;
                        } else if (optionOrderType === "NET_DEBIT" || optionOrderType === "NET_CREDIT") {
                            self.priceDisabled = false;
                        }
                    } else if (orderType === "MARKET") {
                        self.optionOrderTypeSelected = null;
                        self.optionOrderTypeDisabled = true;
                    }

                    break;
                case "setQutoes":
                    let secondLegObj = {
                        "secondLegLastTrade": 0,
                        "secondLegBid": 0,
                        "secondLegAsk": 0,
                        "secondLegMidpoint": 0
                    };
                    if (response.responseStatus === "SUCCESS") {
                        secondLegObj.secondLegLastTrade = response.responseData.secondLegLastTrade;
                        secondLegObj.secondLegBid = response.responseData.secondLegBid;
                        secondLegObj.secondLegAsk = response.responseData.secondLegAsk;
                        secondLegObj.secondLegMidpoint = response.responseData.secondLegMidpoint;
                    }
                    /*TODO: Check with Header part
                    dojo.byId("secondLegLastTrade").innerHTML = secondLegObj.secondLegLastTrade.toFixed(2);
                    dojo.byId("secondLegBid").innerHTML = secondLegObj.secondLegBid.toFixed(2);
                    dojo.byId("secondLegAsk").innerHTML = secondLegObj.secondLegAsk.toFixed(2);
                    dojo.byId("secondLegMidpoint").innerHTML = secondLegObj.secondLegMidpoint.toFixed(2);
                    */
                    break;
                case "getCurrentUnitPrice":
                    /* TODO: Check with Sergey. Integration pending.
                    var firstLegMidpoint = Number(dojo.byId("midpoint").innerHTML),
                    secondLegMidpoint = Number(dojo.byId("secondLegMidpoint").innerHTML);

                    if (firstLegMidpoint && secondLegMidpoint) {
                        return Math.abs(firstLegMidpoint - secondLegMidpoint);
                    }
                    */

                    return 0;

                    break;
                case "priceField":
                    if (response === "EVEN_MONEY") {
                        self.price = null;
                        self.priceDisabled = true;
                    } else if (response === "NET_DEBIT" || response === "NET_CREDIT") {
                        self.price = null;
                        self.priceDisabled = false;
                    }
                    break;
                case "LIMIT":
                    self.optionOrderTypeSelected = null;
                    self.optionOrderTypeDisabled = false;
                    break;
                case "MARKET":
                    self.optionOrderTypeSelected = null;
                    self.optionOrderTypeDisabled = true;
                    break;
                default:
                    break;
            };
        } else {
            self.layoutFieldsShowHide.layExpirationtype = true;
            self.layoutFieldsShowHide.layexpirationdate = true;
            self.layoutFieldsShowHide.layNotHeld = true;
            self.layoutFieldsShowHide.layDestination = true;
            return false;
        }

    }
}
